/**
 * 极小的类型化事件总线，供客户端/SDK 分发状态。
 * 不引入 mitt 等依赖，保持 platform 包零运行时依赖。
 */

export type Unsubscribe = () => void;

export class TypedEmitter<Events extends Record<string, unknown>> {
  private readonly handlers = new Map<keyof Events, Set<(payload: never) => void>>();

  emit<K extends keyof Events>(type: K, payload: Events[K]): void {
    const set = this.handlers.get(type);
    if (!set) return;
    for (const handler of [...set]) {
      try {
        (handler as (value: Events[K]) => void)(payload);
      } catch (error) {
        // 单个监听器异常不能影响其它监听器与主流程
        console.error('[support] event handler failed', error);
      }
    }
  }

  on<K extends keyof Events>(type: K, handler: (payload: Events[K]) => void): Unsubscribe {
    let set = this.handlers.get(type);
    if (!set) {
      set = new Set();
      this.handlers.set(type, set);
    }
    set.add(handler as (payload: never) => void);
    return () => {
      set?.delete(handler as (payload: never) => void);
    };
  }

  offAll(): void {
    this.handlers.clear();
  }
}